import React, { useMemo, useState } from 'react';
import { Link } from '../link';
import classNames from 'classnames';
import { getLinkInformation } from '../../utils/functions';
import { Wrapper } from '../../utils/components';
import { graphql, useStaticQuery } from 'gatsby';
import Minus from '../../atoms/static-icons/minus';
import Plus from '../../atoms/static-icons/plus';

const MenuFooterFirstLevelItem = ({ item }) => {
  const [isOpen, setisOpen] = useState(false);

  function toggleOpen(e) {
    if (e.target.tagName !== 'A') {
      setisOpen(!isOpen);
    }
  }

  const linkInformation = getLinkInformation(
    item.content.columnInternalLink?.value?.link,
    item.content.columnExternalLink.value,
    item.value,
    item.content.columnInternalLink?.value?.pageTitle?.value
  );

  return (
    <Wrapper
      className={classNames('footer__website-navigation-bar--title', {
        open: isOpen,
        'forced-open': linkInformation.link,
      })}
      tag='h4'
      component={linkInformation.link && Link}
      to={linkInformation.link}
      onClick={(e) => toggleOpen(e)}
    >
      {linkInformation.label && <>{linkInformation.label}</>}
      {!linkInformation.link && (
        <span className='footer__website-navigation-bar--icon'>
          {isOpen ? <Minus /> : <Plus />}
        </span>
      )}
    </Wrapper>
  );
};

const MenuFooterSecondLevelItem = ({ item }) => {
  const linkInformation = getLinkInformation(
    item.content.internalLink?.value?.link,
    item.content.externalLink.value,
    item.value,
    item.content.internalLink?.value?.pageTitle?.value
  );

  return (
    <li className='footer__website-navigation-bar--item'>
      <Wrapper
        className='footer__website-navigation-bar--link'
        tag='span'
        component={linkInformation.link && Link}
        to={linkInformation.link}
      >
        {linkInformation.label && <span>{linkInformation.label}</span>}
      </Wrapper>
    </li>
  );
};

const MenuFooterMain = ({ langCode }) => {
  const { footerPages } = useStaticQuery(
    graphql`
      {
        footerPages: allLiferayMenuFooterMain(
          filter: { liferayFields: { title: { eq: "Menu - Footer - Main" } } }
        ) {
          nodes {
            liferayFields {
              langCode
            }
            columnLabelLink {
              value
              content {
                columnInternalLink {
                  value {
                    ... on LiferayPageGeneric {
                      link
                      pageTitle {
                        value
                      }
                    }
                    ... on LiferayModuleDetailProduct {
                      link
                      pageTitle: detailPageTitle {
                        value
                      }
                    }
                    ... on LiferayModuleDetailBlog {
                      link
                      pageTitle: detailPageTitle {
                        value
                      }
                    }
                    ... on LiferayModuleDetailIniziative {
                      link
                      pageTitle: detailPageTitle {
                        value
                      }
                    }
                  }
                }
                columnExternalLink {
                  value
                }
                columnLinkNotVisible {
                  value
                }
                labelLink {
                  value
                  content {
                    internalLink {
                      value {
                        ... on LiferayPageGeneric {
                          link
                          pageTitle {
                            value
                          }
                        }
                        ... on LiferayModuleDetailProduct {
                          link
                          pageTitle: detailPageTitle {
                            value
                          }
                        }
                        ... on LiferayModuleDetailBlog {
                          link
                          pageTitle: detailPageTitle {
                            value
                          }
                        }
                        ... on LiferayModuleDetailIniziative {
                          link
                          pageTitle: detailPageTitle {
                            value
                          }
                        }
                      }
                    }
                    externalLink {
                      value
                    }
                    linkNotVisible {
                      value
                    }
                  }
                }
              }
            }
          }
        }
      }
    `
  );

  const firstLevelPages = useMemo(() => {
    const menu = footerPages.nodes.find(
      (node) => node.liferayFields.langCode === langCode
    );
    return menu?.columnLabelLink
      ?.map((item) => {
        return {
          ...item,
          content: {
            ...item.content,
            secondLevelPages: item.content?.labelLink?.filter(
              (subItem) =>
                (subItem?.value ||
                  subItem.content?.externalLink?.value ||
                  subItem.content?.internalLink?.value?.link) &&
                !subItem.content?.linkNotVisible?.value
            ),
          },
        };
      })
      ?.filter(
        (item) =>
          (item?.value ||
            item.content?.columnExternalLink?.value ||
            item.content?.columnInternalLink?.value?.link) &&
          !item.content?.columnLinkNotVisible?.value
      );
  }, [footerPages, langCode]);

  return (
    <nav
      className='footer__website-navigation-bar'
      data-submodule-name='menu-footer-main'
    >
      {firstLevelPages?.map((firstLevelPage, index) => (
        <div
          className='footer__website-navigation-bar--column'
          key={firstLevelPage.value || index}
        >
          <MenuFooterFirstLevelItem item={firstLevelPage} />
          <ul className='footer__website-navigation-bar--list'>
            {firstLevelPage?.content?.secondLevelPages?.map(
              (secondLevelPage, index) => (
                <MenuFooterSecondLevelItem
                  item={secondLevelPage}
                  key={secondLevelPage.value || index}
                />
              )
            )}
          </ul>
        </div>
      ))}
    </nav>
  );
};

export default MenuFooterMain;
